// Shared number formatting used across every page. Lives in `common` so any
// component (stat cards, filter chips, pagination, …) can use one rule.

// The global stat-number formatter — thousands grouped with commas
// (3575 → "3,575"). Used for every stat-card value, filter-chip count, and the
// pagination total across all pages so large counts read cleanly. null /
// undefined render as "0".
export function fmtNum(n: number | null | undefined): string {
  return (n ?? 0).toLocaleString('en-IE');
}
